const initialState = {
  tabs: {}
};

const tabsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'tabs':
      return {
        ...state,
        tabs: action.payload
      };

    default:
      return state;
  }
};

export default tabsReducer;
